import { ErrorHandler, NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { BlocksModule } from './blocks/blocks.module';
import { AppComponent } from './blocks/root/app.component';
import { SharedModule } from './shared/shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MatFormFieldModule,
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found/page-not-found.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpInterceptor } from './core/common-services/interceptor.service';
import { FileUploaderComponent } from './shared/components/file-uploader/file-uploader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import { ExportExcelComponent } from './shared/components/export-excel/export-excel.component';
import { TimezoneInterceptor } from './core/common-services/time-zone-Interceptor';
import { ConfirmationDialogComponent } from './shared/components/confirmation-dialog/confirmation-dialog.component';
import { CashStatementDialogComponent } from './shared/components/cash-statement-dialog/cash-statement-dialog.component';
import { TruncatePipe } from './shared/pips/truncate.pipe';
import { LoadingInterceptor } from './core/common-services/loading.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import * as Sentry from '@sentry/angular';
import { SentryService } from './core/common-services/sentry.service';
import { AppConfigService } from './core/config/app-config.service';

@NgModule({
  declarations: [ConfirmationDialogComponent, CashStatementDialogComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BlocksModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    BrowserAnimationsModule,
    NgSelectModule,
    TranslateModule.forRoot(),
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple',
    }),
  ],

  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
      deps: [TranslateService],
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TimezoneInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    // Sentry Error Handler - captures all unhandled exceptions
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false, // Set to true to show user feedback dialog
        logErrors: true,
      }),
    },
    // Sentry Trace Service - enables performance monitoring for router navigations
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    // Initialize Sentry Trace Service on app startup
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    // Initialize App Config Service on app startup
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: AppConfigService) => () => configService.loadAppConfig(),
      deps: [AppConfigService],
      multi: true,
    },
    // Provide SentryService for user context management
    SentryService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
